import {StyleSheet} from 'react-native';

const styles = StyleSheet.create({
  full: {
    flex: 1,
  },
});

export default styles;
